module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/",
      "title": "优化指数"
    }
  }, [_vm._v("易展优化指数")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.uname),
      expression: "user.uname"
    }],
    staticClass: "islogin-container"
  }, [_c('span', [_vm._v("您好,")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.uname))]), _vm._v(" "), _c('span', {
    staticClass: "exit",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" [ 退出 ]")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.user.uname),
      expression: "!user.uname"
    }],
    staticClass: "nologin-container"
  }, [_c('span', {
    staticClass: "login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "reg",
    attrs: {
      "href": "http://www.yi-z.cn/Default_oldPage.aspx#reg",
      "target": "_blank"
    }
  }, [_vm._v("注册")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a719178!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/header.vue
// module id = 181
// module chunks = 2